import { create } from 'zustand';

// Camera device selection/persistence moved to services/camera/ (CameraManager
// owns the `camera-device` localStorage key itself now, under a richer
// { deviceId, facingMode, width, height, timestamp } shape) — this store is
// audio-only.
const getStoredDevice = key => {
  const stored = localStorage.getItem(key);
  return stored ? JSON.parse(stored) : 0;
};

export const useDevice = create(set => ({
  audioDevice: getStoredDevice('audio-device'),
  changeAudioDevice: value => {
    localStorage.setItem('audio-device', JSON.stringify(value));
    set({ audioDevice: value });
  },
}));
